<template>
  <BaseModal
    :value="dialogState"
    :modal-title="title"
    @click:outside="close"
    @close="close"
  >
    <template #modal>
      <div>
        <BaseTextField
          ref="labelField"
          v-model="label"
          :label="`${$t('utils.label')} *`"
        />
        <BaseTextField
          v-model="description"
          :label="`${$t('utils.description')}`"
        />
        <div class="colors">
          <div
            v-for="c in colorAvailables"
            :key="`tag-choice-color-${c}`">
            <BaseButtonIcon
              v-if="c == color"
              class="tag-color"
              :style="{ backgroundColor: c }"
              color="primary"
              icon="$mdiCheck"
              size="12"
              />
            <BaseButtonIcon
              v-else
              class="tag-color"
              :style="{ backgroundColor: c }"
              color="primary"
              icon=""
              size="12"
              @click="color = c"
              />
          </div>
        </div>
      </div>
    </template>
    <template #actions>
      <BaseButton
        text
        class="mx-2 ml-auto"
        type="secondary"
        color="#707080"
        @click="close"
      >
        {{ $t("utils.cancel") }}
      </BaseButton>
      <BaseButton color="primary" type="primary" @click="submit">
        {{ submitTitle }}
      </BaseButton>
    </template>
  </BaseModal>
</template>



<script>
import TagApi from "@/modules/Folder/Services/tag.api.js";

export default {
  name: "OrganizationTagEditDialog",
  props: {
    dialogState: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      label: "",
      description: "",
      color: "#ffc9c9",
      colorAvailables: [
        "#ffc9c9",
        "#b2f2bb",
        "#a5d8ff",
        "#ffec99",
        "#eebefa",
      ],
    };
  },
  computed: {
    title() {
      return this.tag ? this.$t("organization_tag_edit_dialog.editTitle") : this.$t("organization_tag_edit_dialog.createTitle");
    },
    submitTitle() {
      return this.tag ? this.$t("utils.edit") : this.$t("utils.create");
    },
  },
  watch: {
    dialogState(value) {
      if (value) {
        setTimeout(() => {
          this.$refs.labelField?.$el?.querySelector("input")?.focus();
        }, 100);
      }
    },
    tag: function(newVal) {
      this.label = newVal?.label || "";
      this.description = newVal?.description || "";
      this.color = newVal?.color || "#ffc9c9";
    },
  },
  methods: {
    close() {
      this.label = "";
      this.description = "";
      this.color = "#ffc9c9";

      this.$emit("closed");
    },
    async submit() {
      try {
        let formData = new FormData();
        formData.append("label", this.label);
        formData.append("description", this.description);
        formData.append("color", this.color);
        if (this.tag) {
          await TagApi.updateOrganizationTag(this.$route.params.organizationId, formData);
        } else {
          await TagApi.createOrganizationTag(this.$route.params.organizationId, formData);
        }
        this.$emit("saved");
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.success"),
          type: "SUCCESS",
        });
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }

      this.close();
    },
  },
};
</script>



<style lang="scss" scoped>
.colors {
  display: flex;
  flex-direction: row;
  gap: 6px;
}

.tag-color {
  width: 24px;
  height: 24px;
  border-radius: 24px;
  padding: 4px;
}
</style>
